export default __webpack_public_path__ + "static/media/header.d138af27.png";